import React, { useState, useEffect } from 'react';
import '../../styles/teacher/RightSidebar.css';
import { fetchEnrolledStudents } from '../../utils/enrolledStudentsService';

const RightSidebar = ({ onStudentClick }) => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFloatingList, setShowFloatingList] = useState(false);

  const notifications = [
    { id: 1, type: 'assignment', message: 'Carol has a doubt in History - History of US', time: '2 min ago' },
    { id: 2, type: 'message', message: 'Parent meeting request from Bob\'s mom', time: '15 min ago' }
  ];

  // Fetch enrolled students on component mount
  useEffect(() => {
    const loadEnrolledStudents = async () => {
      try {
        console.log('🔄 Loading enrolled students...');
        const data = await fetchEnrolledStudents();
        
        if (data && data.students) {
          setStudents(data.students);
          console.log('✅ Enrolled students loaded:', data.students.length, 'students');
        } else {
          console.warn('⚠️ No students data received');
          setStudents([]);
        }
      } catch (error) {
        console.error('❌ Error loading enrolled students:', error);
        setStudents([]);
      } finally {
        setLoading(false);
      }
    };

    loadEnrolledStudents();
  }, []);

  return (
    <div className="right-sidebar-teacher">
      <div className="sidebar-section">
        <h3>Notifications</h3>
        <div className="notifications">
          {notifications.map((notification) => (
            <div key={notification.id} className={`notification-item ${notification.type}`}>
              <div className="notification-content">
                <span className="notification-message">{notification.message}</span>
                <span className="notification-time">{notification.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="sidebar-section">
        <h3>Student Tableau</h3>
        {loading ? (
          <div className="loading-state">
            <p>Loading students...</p>
          </div>
        ) : students.length === 0 ? (
          <div className="no-students">
            <p>No enrolled students found</p>
          </div>
        ) : (
          <>
            <div className="student-tiles-grid">
              {/* Show only the most recent 6 students (last 6 in the array) */}
              {students.slice(-6).map((student) => (
                <div 
                  key={student.id || student.user_id} 
                  className={`student-tile ${student.present ? 'present' : 'absent'}`}
                  onClick={() => onStudentClick(student)}
                >
                  <div className="student-avatar">
                    {student.avatar ? (
                      <img 
                        src={student.avatar} 
                        alt={student.favoriteAnimal || 'Student avatar'} 
                        className="avatar-image"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'block';
                        }}
                      />
                    ) : null}
                    <span className="avatar-emoji-fallback" style={{display: student.avatar ? 'none' : 'block'}}>
                      👤
                    </span>
                    <div className={`attendance-indicator ${student.present ? 'present' : 'absent'}`}>
                      {student.present ? '✓' : '✗'}
                    </div>
                  </div>
                  <div className="student-tile-info">
                    <span className="student-tile-name">{student.name || 'Unknown Student'}</span>
                    <span className="student-tile-grade">{student.grade || 'N/A'}</span>
                  </div>
                </div>
              ))}
            </div>
            {students.length > 6 && (
              <>
                <button 
                  className="expand-collapse-btn"
                  onClick={() => setShowFloatingList(!showFloatingList)}
                >
                  {showFloatingList ? 'Hide' : `View All Students (${students.length} total)`}
                </button>
                {showFloatingList && (
                  <>
                    <div 
                      className="floating-list-overlay"
                      onClick={() => setShowFloatingList(false)}
                    ></div>
                    <div className="floating-student-list">
                      <div className="floating-list-header">
                        <h4>All Students</h4>
                        <button 
                          className="close-floating-list"
                          onClick={() => setShowFloatingList(false)}
                        >
                          ×
                        </button>
                      </div>
                      <div className="floating-list-content">
                        {students.map((student, index) => (
                          <div 
                            key={student.id || student.user_id} 
                            className={`floating-student-item ${student.present ? 'present' : 'absent'}`}
                            onClick={() => {
                              onStudentClick(student);
                              setShowFloatingList(false);
                            }}
                          >
                            <div className="floating-student-avatar">
                              {student.avatar ? (
                                <img 
                                  src={student.avatar} 
                                  alt={student.favoriteAnimal || 'Student avatar'} 
                                  className="avatar-image"
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'block';
                                  }}
                                />
                              ) : null}
                              <span className="avatar-emoji-fallback" style={{display: student.avatar ? 'none' : 'block'}}>
                                👤
                              </span>
                              <div className={`attendance-indicator ${student.present ? 'present' : 'absent'}`}>
                                {student.present ? '✓' : '✗'}
                              </div>
                            </div>
                            <div className="floating-student-info">
                              <span className="floating-student-name">{student.name || 'Unknown Student'}</span>
                              <span className="floating-student-grade">{student.grade || 'N/A'}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default RightSidebar;